const e=(e,c)=>!!Object.values(e).includes(c);export{e as objectHasValue};
//# sourceMappingURL=objectHasValue.js.map
